export const buttonMixin = {
  methods: {
    onMouseup(e) {
      e.currentTarget.blur();
    },
  },
};
